import { useEffect } from "react";
import { useMotionValue, useSpring } from "framer-motion";

export const useMouseParallax = (strength = 1, enabled = true) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 42, damping: 18 });
  const sy = useSpring(my, { stiffness: 42, damping: 18 });
  useEffect(() => {
    if (!enabled) return undefined;
    let raf = 0;
    let nextX = 0;
    let nextY = 0;
    const onMove = (e) => {
      nextX = (e.clientX / window.innerWidth - 0.5) * strength;
      nextY = (e.clientY / window.innerHeight - 0.5) * strength;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        mx.set(nextX);
        my.set(nextY);
        raf = 0;
      });
    };
    window.addEventListener("pointermove", onMove, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onMove);
    };
  }, [enabled, mx, my, strength]);
  return [sx, sy];
};
